var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5C6.17237 13.5 5.5 12.8271 5.5 11.9988C5.5 11.1729 6.17237 10.5 7 10.5C7.82763 10.5 8.5 11.1729 8.5 11.9988C8.5 12.8271 7.82763 13.5 7 13.5Z",
    fill: "#433E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C11.1724 13.5 10.5 12.8271 10.5 11.9988C10.5 11.1729 11.1724 10.5 12 10.5C12.8276 10.5 13.5 11.1729 13.5 11.9988C13.5 12.8271 12.8276 13.5 12 13.5Z",
    fill: "#433E3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.5C16.1724 13.5 15.5 12.8271 15.5 11.9988C15.5 11.1729 16.1724 10.5 17 10.5C17.8276 10.5 18.5 11.1729 18.5 11.9988C18.5 12.8271 17.8276 13.5 17 13.5Z",
    fill: "#433E3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.015C1 6.22869 5.62349 1 12.02 1C18.2757 1 23 6.12738 23 11.985C23 18.7925 17.4331 23 12 23C10.2 23 8.20137 22.5195 6.57234 21.5596L6.55879 21.5515C6.29859 21.3926 6.16149 21.3216 6.05631 21.2893C5.98984 21.2689 5.95765 21.2693 5.90146 21.2878C5.89258 21.2907 5.88365 21.2935 5.87469 21.2961L3.86063 21.8943C3.28936 22.0704 2.67266 21.9491 2.23477 21.5455C1.7833 21.1294 1.617 20.5007 1.78638 19.89L1.79182 19.8711L2.46182 17.6277C2.46652 17.612 2.47161 17.5963 2.47708 17.5809C2.4877 17.5508 2.48921 17.5299 2.48905 17.5202C2.48298 17.5099 2.47708 17.4995 2.47138 17.489C1.544 15.7827 1 13.8883 1 12.015ZM12.02 3C6.79651 3 3 7.26355 3 12.015C3 13.5006 3.4324 15.0626 4.2188 16.5159C4.53899 17.0581 4.55353 17.6851 4.37217 18.2201L3.9016 19.7958L5.2937 19.3823C6.31069 19.0564 7.10495 19.5415 7.59124 19.8385L7.59425 19.8404C8.8842 20.5985 10.5225 21 12 21C16.4869 21 21 17.536 21 11.985C21 7.18459 17.1243 3 12.02 3Z",
    fill: "#433E3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d4e4a51a.svg";
export { ForwardRef as ReactComponent };